import { useMemo, useRef, useState } from "react";
import { Trans, t } from "@lingui/macro";
import { FiPlus, FiTwitter } from "react-icons/fi";
import { useCopyToClipboard } from "react-use";
import { IoWarningOutline } from "react-icons/io5";
import { BiCopy, BiErrorCircle } from "react-icons/bi";
import Card from "../Common/Card";
import Modal from "../Modal/Modal";
import { shortenAddress } from "lib/legacy";
import EmptyMessage from "./EmptyMessage";
import InfoCard from "./InfoCard";
import {
  getReferralCodeTradeUrl,
  getTierIdDisplay,
  getTwitterShareUrl,
  getUSDValue,
  isRecentReferralCodeNotExpired,
  tierRebateInfo,
  floor
} from "./referralsHelper";
import { AffiliateCodeForm } from "./AddAffiliateCode";
import TooltipWithPortal from "../Tooltip/TooltipWithPortal";
import { getExplorerUrl, OPTEST } from "config/chains";
import { helperToast } from "lib/helperToast";
import { bigNumberify, formatAmount } from "lib/numbers";
import { getNativeToken, getToken } from "config/tokens";
import { formatDate } from "lib/dates";

function AffiliatesStats ({
  referralsData,
  handleCreateReferralCode,
  chainId,
  setRecentlyAddedCodes,
  recentlyAddedCodes,
  userReferrerReward,
  userTradeReward,
  addressBycode
}) {

  const [isAddReferralCodeModalOpen, setIsAddReferralCodeModalOpen] = useState(false);
  const addNewModalRef = useRef(null);
  const [, copyToClipboard] = useCopyToClipboard();
  const open = () => setIsAddReferralCodeModalOpen(true);
  const close = () => setIsAddReferralCodeModalOpen(false);
  const {  referrerTotalStats, rebateDistributions, referrerTierInfo } = referralsData;
  const allReferralCodes = referrerTotalStats.map((c) => c.referralCode.trim());
  const finalAffiliatesTotalStats = useMemo(
    () =>
      recentlyAddedCodes.filter(isRecentReferralCodeNotExpired).reduce((acc, cv) => {
        if (!allReferralCodes.includes(cv.referralCode)) {
          acc = acc.concat(cv);
        }
        return acc;
      }, referrerTotalStats),
    [allReferralCodes, referrerTotalStats, recentlyAddedCodes]
  );


  return (
    <div className="referral-body-container">
      {/* <div className="referral-stats">
        
        <InfoCard
          label={t`Total Traders Referred`}
          tooltipText={t`Amount of traders you referred.`}
          data={cumulativeStats?.registeredReferralsCount || "0"}
        />
        <InfoCard
          label={t`Team Data`}
          tooltipText={t`Volume traded by your referred traders.`}
          data={getUSDValue(cumulativeStats?.volume)}
        />
        <InfoCard
          label={t`Award`}
          tooltipText={t`Rebates earned by this account as an affiliate.`}
          data={getUSDValue(referrerRebates, 4)}
        />
      </div> */}
      <div className="referral-detailed-data">
        <div className="information-card">
          <div className="information-card-title">
            <Trans>Recommended traders</Trans>
          </div>
          <div className="information-card-divider"></div>
          <div className="information-card-content">
            <div className="information-card-row">
              <div className="data">{userReferrerReward.referCount}</div>
            </div>
          </div>
        </div>
        <div className="information-card">
          <div className="information-card-title">
            <Trans>Teams Data</Trans>
          </div>
          <div className="information-card-divider"></div>
          <div className="information-card-content">
            <div className="information-card-row">
              <div className="label">
                <Trans>Cumulative trading volume</Trans>
              </div>


              <div className="value">${floor(userTradeReward.traderVolumeSum)}</div>
            </div>
            <div className="information-card-row">
              <div className="label">
                <Trans>Trading volume this week</Trans>
              </div>
              <div className="value">${floor(userReferrerReward.tradeVolume)}</div>
            </div>
          </div>
        </div>
        <div className="information-card">
          <div className="information-card-title">
            <Trans>Reward</Trans>
          </div>
          <div className="information-card-divider"></div>
          <div className="information-card-content">
            <div className="information-card-row">
              <div className="label">
                <Trans>Cumulative rewards</Trans>
              </div>
              <div className="value">${floor(userReferrerReward.affiliateSum)}</div>
            </div>
            <div className="information-card-row">
              <div className="label">
                <Trans>Reward of the week</Trans>
              </div>
              <div className="value">${floor(userReferrerReward.affiliateUsd)}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="list">
        <Modal
          className="Connect-wallet-modal"
          isVisible={isAddReferralCodeModalOpen}
          setIsVisible={close}
          label={t`Create Referral Code`}
          onAfterOpen={() => addNewModalRef.current?.focus()}
        >
          <div className="edit-referral-modal">
            <AffiliateCodeForm
              handleCreateReferralCode={handleCreateReferralCode}
              // recentlyAddedCodes={recentlyAddedCodes}
              setRecentlyAddedCodes={setRecentlyAddedCodes}
              callAfterSuccess={close}
            />
          </div>
        </Modal>
        <Card
          title={
            <div className="referral-table-header">
              <p className="title">
                <Trans>Referral Codes</Trans>
                <span className="sub-title">
                  {referrerTierInfo && t`Tier ${addressBycode.level} (${addressBycode.levelRate}% rebate)`}
                </span>
              </p>
              {/* <button className="transparent-btn" onClick={open}>
                <FiPlus /> <span className="ml-small">Create</span>
              </button> */}
            </div>
          }
        >

          <div className="table-wrapper">
            <table className="referral-table">
              <thead>
                <tr>
                  <th className="table-head" scope="col">
                    <Trans>Recommend code</Trans>
                  </th>
                  <th className="table-head" scope="col">
                    <Trans>Cumulative trading volume</Trans>
                  </th>
                  <th className="table-head" scope="col">
                    <Trans>Trading volume this week</Trans>
                  </th>
                  <th className="table-head" scope="col">
                    <Trans>Recommended Traders</Trans>
                  </th>
                  <th className="table-head" scope="col">
                    <Trans>Cumulative rewards</Trans>
                  </th>
                  <th className="table-head" scope="col">
                    <Trans>Reward of the week</Trans>
                  </th>
                </tr>
              </thead>
              <tbody>

                {finalAffiliatesTotalStats.map((stat, index) => {
                  const ownerOnOtherChain = stat?.ownerOnOtherChain;
                  let referrerRebate = bigNumberify(0);
                  if (stat && stat.totalRebateUsd && stat.discountUsd) {
                    referrerRebate = stat.totalRebateUsd.sub(stat.discountUsd);
                  }
                  return (
                    <tr key={index}>
                      <td data-label="Referral Code">
                        <div className="table-referral-code">
                          <span className="referral-text ">
                            {addressBycode.code}
                          </span>
                          <div
                            onClick={() => {
                              copyToClipboard(getReferralCodeTradeUrl(addressBycode.code));
                              helperToast.success(t`Referral link copied to your clipboard`);
                            }}
                            className="referral-code-icon"
                          >
                            <BiCopy />
                          </div>
                          <a
                            href={getTwitterShareUrl(stat.referralCode)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="referral-code-icon"
                          >
                            <FiTwitter />
                          </a>
                          {ownerOnOtherChain && !ownerOnOtherChain?.isTaken && (
                            <div className="info">
                              <TooltipWithPortal
                                position="right"
                                handle={<IoWarningOutline color="#ffba0e" size={16} />}
                                renderContent={() => (
                                  <div>
                                    <Trans>
                                      This code is not yet registered on{" "}
                                      optimism, you will not receive rebates
                                      there.
                                      <br />
                                      <br />
                                      Switch your network to create this code on optimism.
                                    </Trans>
                                  </div>
                                )}
                              />
                            </div>
                          )}
                          {ownerOnOtherChain && ownerOnOtherChain?.isTaken && !ownerOnOtherChain?.isTakenByCurrentUser && (
                            <div className="info">
                              <TooltipWithPortal
                                position="right"
                                handle={<BiErrorCircle color="#e82e56" size={16} />}
                                renderContent={() => (
                                  <div>
                                    <Trans>
                                      This code has been taken by someone else on{" "}
                                      optimism, you will not receive rebates
                                      from traders using this code on optimism.
                                    </Trans>
                                  </div>
                                )}
                              />
                            </div>
                          )}
                        </div>
                      </td>
                      <td data-label="Total Volume">{`$${floor(userTradeReward.traderVolumeSum)}`}</td>
                      <td data-label="Week Trade">{`$${floor(userReferrerReward.tradeVolume)}`}</td>
                      <td data-label="Traders Referred">{userReferrerReward.referCount}</td>
                      <td data-label="Total Rebates">{`$${floor(userReferrerReward.affiliateSum)}`}</td>
                      <td data-label="Week Award">{`$${floor(userReferrerReward.affiliateUsd)}`}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
      {rebateDistributions?.length > 0 ? (
        <div className="reward-history">
          <Card title="Rewards Distribution History" tooltipText="Rewards are airdropped weekly.">
            <div className="table-wrapper">
              <table className="referral-table">
                <thead>
                  <tr>
                    <th className="table-head" scope="col">
                      <Trans>Date</Trans>
                    </th>
                    <th className="table-head" scope="col">
                      <Trans>Amount</Trans>
                    </th>
                    <th className="table-head" scope="col">
                      <Trans>Transaction</Trans>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {rebateDistributions.map((rebate, index) => {
                    let tokenInfo;
                    try {
                      tokenInfo = getToken(chainId, rebate.token);
                    } catch {
                      tokenInfo = getNativeToken(chainId);
                    }
                    const explorerURL = getExplorerUrl(chainId);
                    return (
                      <tr key={index}>
                        <td className="table-head" data-label="Date">
                          {formatDate(rebate.timestamp)}
                        </td>
                        <td className="table-head" data-label="Amount">
                          {formatAmount(rebate.amount, tokenInfo.decimals, 6, true)} {"AVT"}
                        </td>
                        <td className="table-head" data-label="Transaction">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={explorerURL + `tx/${rebate.transactionHash}`}
                          >
                            {shortenAddress(rebate.transactionHash, 13)}
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      ) : (
        <EmptyMessage
          tooltipText={t`Rebates are airdropped weekly.`}
          message={t`No Rebates Distribution history yet.`}
        />
      )}
    </div>
  );
}

export default AffiliatesStats;
